import React from 'react';
import SocialMedia from './socialCard.jsx';
import {HashRouter as Router, Link} from 'react-router-dom';
function closetab() {
    var open = document.getElementById("left");
    var bar = document.getElementById("bar");
    var close = document.getElementById("close");
    open.style.display = "none";
    bar.style.display = "block";
    close.style.display = "none";
  
  }
function LeftPanel() {
    return (
        <div className="left" id="left">
            <div className="ID_card">
                <div className="ID_tag"></div>
            <div className="profileImg">
                <img src={require("../img/newProfile.jpeg")} alt="Ninad" id="profileImg" />
            </div>
            <p id="nameHead">Ninad Dadmal</p>
            <div className="professionalStatus">
                <p>Junior Year Computer Science Undergraduate Student 2022</p>
            </div>
            </div>
            <Router>
            <div className="browse">
                <Link to="/" onClick={closetab}><p>Home</p></Link>
                <Link to="/projects" onClick={closetab}><p>Projects</p></Link>
            </div>
            </Router>
            <div className="media">
                <p id="touch">Get in touch</p>
                <SocialMedia name="LinkedIn" imgsrc={require("../img/icons8-linkedin-50.png")} website="https://www.linkedin.com/in/ninad-d-706277b6/" />
                <SocialMedia name="GitHub" imgsrc={require("../img/icons8-github-48.png")} website="https://github.com/Ninad10code/" />
                <SocialMedia name="Facebook" imgsrc={require("../img/icons8-facebook-48.png")} website="https://www.facebook.com/profile.php?id=100011791892179" />
                <SocialMedia name="Twitter" imgsrc={require("../img/icons8-twitter-48.png")} website="https://twitter.com/ninad_dadmal" />
                <SocialMedia name="Mail" imgsrc={require("../img/icons8-important-mail-48.png")} website="mailto:ninad.dadmal10@gmail.com" />
            </div>
        </div>
    );
}

export default LeftPanel;